import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import StageModel from "@fae/source/models/Stage.js"

import Navigation from "@fae/source/engine/navigating/Navigation.js"

// import ModalUI from "@fae/source/views/ModalUI.jsx"
import Frame from "@fae/source/views/components/Frame.jsx"
import TitleSplashScreen from "@fae/source/views/components/TitleSplashScreen.jsx"
import games from "@fae/source/data/games"

import "./TitleScreen.less"

export default function TitleScreen() {
    if(App.game == undefined) return
    let stage = App.getActiveStage()

    function onStartGame(game) {
        return function(event) {
            // Navigation.go("/games/ember/embark")
            Navigation.go("/games/ember/chapters/X-0")
        }
    }

    // <ModalUI stage={stage}/>
    return (
        <Frame>
            <TitleSplashScreen>
                <div class="Ember TitleScreen">
                    <div class="Contents">
                        <img class="Title" src={require("@fae/source/assets/images/ember-tactics/embergrim.logo.png")}/>
                        <div class="Buttons">
                            <div class="Button" onClick={onStartGame(games["ember"])}>Play</div>
                            <div class="Button">Settings</div>
                            <div class="Button" onClick={() => window.nativeAPI?.quit()}>Quit</div>
                        </div>
                    </div>
                </div>
            </TitleSplashScreen>
        </Frame>
    )
}
